import React from 'react';

import { i18n } from 'config/locales';

import { Summary } from 'components/Summary';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';

import { FINANCIAL, FINANCIAL_CREDIT } from 'config/formSections/financial';

import Branch from 'components/Form/Branch';
import NotApplicable from 'components/Form/NotApplicable';
import { EmptyListInstance } from 'forms/shared/models';
import { EmptyBranch } from 'forms/shared/validators/models/branch/instance';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import { isPVQForm } from 'helpers/form';
import CreditItem from './CreditItem';

const sectionConfig = {
  key: FINANCIAL_CREDIT.key,
  section: FINANCIAL.name,
  store: FINANCIAL.store,
  subsection: FINANCIAL_CREDIT.name,
  storeKey: FINANCIAL_CREDIT.storeKey,
};

export class Credit extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      HasCreditCounseling: this.props.HasCreditCounseling,
      HasCreditCounselingNotApplicable: this.props.HasCreditCounselingNotApplicable,
      List: this.props.List,
      ...queue,
    });
  };

  /**
   * Updates triggered by the branching component.
   */
  updateBranch = (values) => {
    this.update({
      HasCreditCounseling: values,
      List: values.value === 'Yes' ? this.props.List : {},
    });
  };

  updateHasCreditCounselingNotApplicable = (values) => {
    const isApplicable = values?.applicable;
    this.update({
      HasCreditCounselingNotApplicable: values,
      HasCreditCounseling: isApplicable ? this.props.HasCreditCounseling : EmptyBranch(),
      List: isApplicable ? this.props.List : EmptyListInstance,
    });
  };

  /**
   * Dispatch callback initiated from the collection to notify of any new
   * updates to the items.
   */
  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  /**
   * Assists in rendering the summary section.
   */
  summary = (item, index) => {
    const obj = item.Item || {};
    const name = (obj.Name || {}).value || '';

    return Summary({
      type: i18n.t('financial.credit.collection.summary.item'),
      index,
      left: name,
      right: null,
      placeholder: i18n.t('financial.credit.collection.summary.unknown'),
    });
  };

  render() {
    const { errors, formType } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);
    const isPVQ = isPVQForm(formType);

    return isPVQ ? (
      <div
        className="section-content credit-counseling"
        data-section={FINANCIAL.key}
        data-subsection={FINANCIAL_CREDIT.key}
      >
        <h1 className="section-header">{i18n.t('financial.destination.credit')}</h1>
        <NotApplicable
          {...this.props.HasCreditCounselingNotApplicable}
          label={i18n.t('financial.pvq.shared.na')}
          attribute="HasCreditCounselingNotApplicable"
          onUpdate={this.updateHasCreditCounselingNotApplicable}
          scrollIntoView={this.props.scrollIntoView}
          required={this.props.required}
          useChangeWarning
        >
          <Branch
            attribute="HasCreditCounseling"
            name="has_credit"
            label={isPVQ ? i18n.t('financial.pvq.counseling.branch.title') : i18n.t('financial.credit.title')}
            labelSize="h4"
            className="credit-branch"
            {...this.props.HasCreditCounseling}
            warning
            onUpdate={this.updateBranch}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            onError={this.handleError}
          />
        </NotApplicable>
        <Show when={(this.props.HasCreditCounseling || {}).value === 'Yes'}>
          <Accordion
            attribute="List"
            {...this.props.List}
            defaultState={this.props.defaultState}
            scrollToBottom={this.props.scrollToBottom}
            onUpdate={this.updateList}
            onError={this.handleError}
            summary={this.summary}
            description={i18n.t('financial.credit.collection.summary.title')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            errors={accordionErrors}
            appendTitle={isPVQ ? i18n.t('financial.pvq.counseling.appendTitle') : i18n.t('financial.credit.collection.appendTitle')}
            appendLabel={i18n.t('financial.credit.collection.append')}
          >
            <CreditItem
              name="Item"
              bind
              formType={formType}
              addressBooks={this.props.addressBooks}
              dispatch={this.props.dispatch}
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
            />
          </Accordion>
        </Show>
      </div>
    ) : (
      <div
        className="section-content credit-counseling"
        data-section={FINANCIAL.key}
        data-subsection={FINANCIAL_CREDIT.key}
      >
        <h1 className="section-header">{i18n.t('financial.destination.credit')}</h1>
        <Branch
          attribute="HasCreditCounseling"
          name="has_credit"
          label={isPVQ ? i18n.t('financial.pvq.counseling.branch.title') : i18n.t('financial.credit.title')}
          labelSize="h4"
          className="credit-branch"
          {...this.props.HasCreditCounseling}
          warning
          onUpdate={this.updateBranch}
          required={this.props.required}
          scrollIntoView={this.props.scrollIntoView}
          onError={this.handleError}
        />
        <Show when={(this.props.HasCreditCounseling || {}).value === 'Yes'}>
          <Accordion
            attribute="List"
            {...this.props.List}
            defaultState={this.props.defaultState}
            scrollToBottom={this.props.scrollToBottom}
            onUpdate={this.updateList}
            onError={this.handleError}
            summary={this.summary}
            description={i18n.t('financial.credit.collection.summary.title')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            errors={accordionErrors}
            appendTitle={isPVQ ? i18n.t('financial.pvq.counseling.appendTitle') : i18n.t('financial.credit.collection.appendTitle')}
            appendLabel={i18n.t('financial.credit.collection.append')}
          >
            <CreditItem
              name="Item"
              bind
              formType={formType}
              addressBooks={this.props.addressBooks}
              dispatch={this.props.dispatch}
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
            />
          </Accordion>
        </Show>
      </div>

    );
  }
}

Credit.defaultProps = {
  HasCreditCounseling: {},
  HasCreditCounselingNotApplicable: {},
  List: {},
  addressBooks: {},
  onUpdate: () => {},
  onError: (value, arr) => arr,
  dispatch: () => {},
  defaultState: true,
  scrollToBottom: '.bottom-btns',
  errors: [],
};

export default connectSubsection(Credit, sectionConfig);
